import { useCallback, useEffect, useState } from 'react'

import { API } from '@/api'
import { ServerDomainInfo } from '@/api/type-server'
import { SnapStatus } from '@/consts/snapshot'
import { fetchAllPages } from '@/utils/pagination'

interface UseSnapshotStorageTotalOptions {
  enabled: boolean
  domainInfos: ServerDomainInfo[]
}

export function useSnapshotStorageTotal({ enabled, domainInfos }: UseSnapshotStorageTotalOptions) {
  const [snapshotStorageBytes, setSnapshotStorageBytes] = useState(0)

  const refresh = useCallback(async () => {
    if (!enabled || domainInfos.length === 0) return
    try {
      const allSnapshots = await fetchAllPages({
        fetchPage: (requestPage, requestPageSize) =>
          API.getSnapList({
            domains: domainInfos.map((d) => d.domain),
            page: requestPage,
            per_page: requestPageSize,
            status: [SnapStatus.Finished],
          }),
        getItems: (response) => response.snapshots,
      })
      setSnapshotStorageBytes(
        allSnapshots.reduce((sum, snap) => sum + (Number(snap.sizeByte) || 0), 0),
      )
    } catch (error) {
      console.error('Failed to fetch snapshot storage total:', error)
    }
  }, [enabled, domainInfos])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { snapshotStorageBytes, refresh }
}
